module.exports = __WEBPACK_EXTERNAL_MODULE_82__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 82
// module chunks = 0